import CardDesktop from "./CardDesktop";
import CardMobile from "./CardMobile";
import type { CardDesktopProps, CardProps } from "./Card.d";

export { CardDesktop, CardMobile, CardDesktopProps, CardProps };
